const Testimotial = () => {
  return <div>Here is testimotial page</div>;
};

export default Testimotial;
